export class AnagraficaR {
    public nome: string;
    public cognome: string;
    public indirizzo: string;
    public cap: string;
    public citta: string;
    public provincia: string;
    public cf: string;

    constructor(
        nome: string,
        cognome: string,
        indirizzo: string,
        cap: string,
        citta: string,
        provincia: string,
        cf: string
    ) {
        this.nome = nome;
        this.cognome = cognome
        this.indirizzo = indirizzo;
        this.cap = cap;
        this.citta = citta;
        this.provincia = provincia;
        this.cf = cf;
    }
}
